import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

interface DistributionMTSTableProps {
  mtsData: Array<{
    totalMtsInRegion: number;
    nameRu: string;
    nameKy: string;
    totalTransportInRegion: number;
    mtsDetails: any;
  }>;
}

const getRegionIcon = (name: string): string => {
  const iconMap: { [key: string]: string } = {
    'Чуйская область': '/imageMTS/kg1.svg',
    'Иссык-Кульская область': '/imageMTS/kg2.svg',
    'Таласская область': '/imageMTS/kg3.svg',
    'Джалал-Абадская область': '/imageMTS/kg4.svg',
    'Нарынская область': '/imageMTS/kg5.svg',
    'Ошская область': '/imageMTS/kg6.svg',
    'Баткенская область': '/imageMTS/kg7.svg',
    'Ош': '/imageMTS/kg8.svg',
    'Бишкек': '/imageMTS/kg9.svg',
  };
  return iconMap[name] || '/imageMTS/default.svg';
};

export const DistributionMTSTable: React.FC<DistributionMTSTableProps> = ({ mtsData }) => {
  const { t } = useTranslation();
  const regions = mtsData.map(region => ({
    name: region.nameRu,
    icon: getRegionIcon(region.nameRu),
    count: region.totalMtsInRegion
  }));

  const total = regions.reduce((sum, region) => sum + region.count, 0);

  return (
    <div className={styles.container_main}>
      <h2 className={styles.title}>{t('Distribution of MTS')}</h2>
      <div className={styles.container}>
        <ul className={styles.list}>
          {regions.map((region) => (
            <li key={region.name} className={styles.item}>
              <div className={styles.region}>{region.name}</div>
              <img src={region.icon} alt={region.name} className={styles.regionIcon} />
              <div>
                <div className={styles.count}>{region.count}</div>
                <div>кол-во</div>
              </div>
            </li>
          ))}
          <li className={`${styles.item} ${styles.total}`}>
            <div className={styles.region}>Всего</div>
            <div className={styles.count}>{total}</div>
          </li>
        </ul>
      </div>
    </div>
  );
};